import Icon from "./Icon"

const Pricing = ({data}) => {

    const options = data?.prices ? data.prices : {}

    const questions = data?.questions ? data.questions : []
    
    return <section name='buy' id='buy' className='bg-white p-5 py-40'>
        <div className='container mx-auto max-w-lg '>
            
            <div className='flex gap-10 flex-col text-center '>
                <div className='flex-1'>
                    <Icon name='buy' outer='bg-indigo-50' inner='fill-indigo-400' />
                    <h2>Get it now</h2>
                    <p>Give a twist to your WordPress site with the Animator plugin.<br />
                    It’s a great way to enhance the experience of your users and make a strong first impression.</p>
                </div>
                <div className='flex-1 p-10 bg-gradient-to-tr from-slate-900 to-slate-800 text-slate-300 rounded-2xl'>
                    {Object.keys(options).map((o,i)=>{
                        const {desc,price,link} = options[o]
                        return <>
                            
                            <h2 className='text-white'>{price}</h2>
                            <div>{desc}</div>
                            <div className='bg-slate-700 m-10 rounded-xl p-4'>
                                <div className='py-2 flex gap-4 font-bold items-center justify-center'>
                                    <del className='text-4xl opacity-50'>49$</del>
                                    <span className='text-6xl relative'>
                                        29
                                        <div className='absolute left-full top-0 text-xl'>$</div>
                                    </span>
                                </div>
                                <a className='button primary block mt-4' href={link}>Get it now</a>
                            </div>
                        </>
                    })
                }
                </div>
            </div>
        </div>
    </section>

   
    return <section name='buy' id='buy' className='bg-white p-5 py-40'>
        <div className=' text-center  max-w-prose mx-auto mb-20'>
            <Icon name='buy' outer='bg-teal-50' inner='fill-teal-400' />
            <h2>Get it now</h2>
            <p className='sub'>Give a twist to your WordPress site with the Animator plugin.<br />
It’s a great way to enhance the experience of your users and make a strong first impression.</p>
        </div>
        <div className='max-w-[900px] mx-auto'>
            <div className='flex flex-col lg:flex-row gap-10 justify-center'>
                {Object.keys(options).map((o,i)=>{
             
                return <div key={i} data-name={o} className={'max-w-[450px] flex-1 relative flex flex-col pricingTable'}>
                    <span className='absolute top-0 left-0 w-full flex justify-center gap-5 -mt-8'>
                        <Icon name='logo' inner="fill-slate-700" outer="bg-white rounded-full ring-4 ring-slate-300  ring-opacity-20"/>
                        {o.indexOf('hero')>-1&& <Icon name='hero' inner="fill-slate-700" outer="bg-white rounded-full ring-4 ring-slate-300  ring-opacity-20"/>}
                     
                    </span>
                    <div className='h-full flex flex-col rounded-2xl shadow'>
                        <div className='p-8 pt-10 text-center font-bold text-sm uppercase'>
                            {o.split('-').join(' ')}
                        </div>
                        <div className='font-extrabold flex justify-center'>
                            <div className='text-5xl relative text-center'>
                                {options[o].price}
                                {/* <div className='text-xl absolute top-0 left-full'>
                                    USD
                                </div> */}
                            </div>
                        </div>
                        <div className='p-8 pt-4 text-center'>
                            {options[o].desc}
                        </div>
                        <a href={options[o].link} className='hover:bg-purple-800 transition-all mt-auto btn text-center font-bold p-4 m-4 rounded-lg text-sm'>Signup and buy</a>
                    </div>
                </div>})}
            </div>
            <div className='my-20 max-w-prose mx-auto '>
                
                <h3 className='text-center mb-10'>Frequently Asked Questions</h3>
                {questions.map((q,i)=><div key={i} className='mb-8'>
                    <div className='p-4 pt-0 font-bold flex items-center gap-2'>
                        <div className='w-2 h-2 bg-teal-400 rounded-full'></div>
                        {q.q}
                    </div>
                    <div className='p-4 bg-slate-100 rounded-xl'>{q.a}</div>
                </div>)}
            </div>
        </div>
   
    </section>
}

export default Pricing